import React, { type ReactNode } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { PageHeading, PageDescription } from '../index';

export type StepScreenProps = {
	renderProgressBar?: ReactNode;
	header?: ReactNode;
	description?: ReactNode;
	children?: ReactNode;
	renderFooter?: ReactNode;
	testId?: string;
	maxWidth?: string;
};

export const StepScreen = ({
	renderProgressBar,
	header,
	description,
	children,
	renderFooter,
	testId,
	maxWidth,
}: StepScreenProps) => (
	<Box xcss={wrapperStyles} testId={testId}>
		{renderProgressBar && renderProgressBar}
		<Box
			padding="space.400"
			xcss={[
				contentWrapperStyles,
				...(renderProgressBar ? [wrapperWithProgressBar] : []),
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				...(maxWidth ? [xcss({ maxWidth })] : []),
			]}
		>
			{header && <PageHeading>{header}</PageHeading>}
			{description && <PageDescription>{description}</PageDescription>}
			{children}
		</Box>
		{renderFooter && renderFooter}
	</Box>
);

const wrapperStyles = xcss({
	width: '100%',
	backgroundColor: 'color.background.input',
	overflowY: 'auto',
});

const contentWrapperStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	maxWidth: '1008px',
	margin: 'auto',
	minWidth: '375px',
});

const wrapperWithProgressBar = xcss({
	position: 'relative',
	top: '120px',
	paddingBottom: 'space.1000',
});
